"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSelectedEventCodes = exports.setTruckModel = exports.setSelectedTruckModel = exports.setSelectedTruckModelMobile = exports.initialState = exports.downloadTruckFile = exports.downloadTruckToolParameters = exports.importTruckDefinitionFile = exports.exportTruckDefinitionFile = void 0;
const toolkit_1 = require("@reduxjs/toolkit");
const redux_persist_1 = require("redux-persist");
const utils_1 = __importDefault(require("../utils"));
const request_1 = require("./request");
exports.exportTruckDefinitionFile = (0, toolkit_1.createAsyncThunk)('tdf/export', (uuid, thunk) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, utils_1.default)(thunk, (0, request_1.invokeRequest)({ method: 'get', url: `/v1/tdf/export/${uuid}/`, isBlob: true }));
}));
exports.importTruckDefinitionFile = (0, toolkit_1.createAsyncThunk)('tdf/import', ({ uuid, files }, thunk) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, utils_1.default)(thunk, (0, request_1.invokeRequest)({
        method: 'post',
        url: `/v1/tdf/import/${uuid}/`,
        data: { files },
        isFormData: true
    }));
}));
exports.downloadTruckToolParameters = (0, toolkit_1.createAsyncThunk)('ttp/download', (uuid, thunk) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, utils_1.default)(thunk, (0, request_1.invokeRequest)({ method: 'get', url: `/core/v1/ttp/download/${uuid}`, isBlob: true }));
}));
exports.downloadTruckFile = (0, toolkit_1.createAsyncThunk)('cms/download', ({ fileUrl, truckModel }, thunk) => __awaiter(void 0, void 0, void 0, function* () {
    return (0, utils_1.default)(thunk, (0, request_1.invokeRequest)({
        method: 'get',
        url: `/v1/cms/download?fileUrl=${fileUrl}&truckModel=${truckModel}`,
        isBlob: true
    }));
}));
exports.initialState = {
    selectedTruckModelMobile: null,
    selectedTruckModel: null,
    truckModel: null,
    selectedEventCodes: [],
    loading: false,
    error: undefined
};
const truckModelSlice = (0, toolkit_1.createSlice)({
    name: 'truckModel',
    initialState: exports.initialState,
    reducers: {
        setSelectedTruckModelMobile: (state, action) => {
            state.selectedTruckModelMobile = action.payload;
        },
        setSelectedTruckModel: (state, action) => {
            state.selectedTruckModel = action.payload;
        },
        setTruckModel: (state, action) => {
            state.truckModel = action.payload;
        },
        setSelectedEventCodes: (state, action) => {
            state.selectedEventCodes = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(exports.exportTruckDefinitionFile.pending, (state) => {
            state.loading = true;
        })
            .addCase(exports.exportTruckDefinitionFile.fulfilled, (state) => {
            state.loading = false;
        })
            .addCase(exports.exportTruckDefinitionFile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
            .addCase(exports.importTruckDefinitionFile.pending, (state) => {
            state.loading = true;
        })
            .addCase(exports.importTruckDefinitionFile.fulfilled, (state) => {
            state.loading = false;
        })
            .addCase(exports.importTruckDefinitionFile.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
            .addCase(exports.downloadTruckToolParameters.pending, (state) => {
            state.loading = true;
        })
            .addCase(exports.downloadTruckToolParameters.fulfilled, (state) => {
            state.loading = false;
        })
            .addCase(exports.downloadTruckToolParameters.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        })
            .addCase(redux_persist_1.PURGE, (state) => {
            state.selectedTruckModelMobile = exports.initialState.selectedTruckModelMobile;
            state.selectedTruckModel = exports.initialState.selectedTruckModel;
            state.truckModel = exports.initialState.truckModel;
            state.selectedEventCodes = exports.initialState.selectedEventCodes;
        });
    }
});
_a = truckModelSlice.actions, exports.setSelectedTruckModelMobile = _a.setSelectedTruckModelMobile, exports.setSelectedTruckModel = _a.setSelectedTruckModel, exports.setTruckModel = _a.setTruckModel, exports.setSelectedEventCodes = _a.setSelectedEventCodes;
exports.default = truckModelSlice.reducer;
